export var NOTIFICATION_SEVERITY;
(function (NOTIFICATION_SEVERITY) {
    NOTIFICATION_SEVERITY["SUCCESS"] = "success";
    NOTIFICATION_SEVERITY["ERROR"] = "error";
    NOTIFICATION_SEVERITY["INFO"] = "info";
    NOTIFICATION_SEVERITY["WARNING"] = "warn";
})(NOTIFICATION_SEVERITY || (NOTIFICATION_SEVERITY = {}));
export var NOTIFICATION_SUMMARY;
(function (NOTIFICATION_SUMMARY) {
    NOTIFICATION_SUMMARY["SUCCESS"] = "Success";
    NOTIFICATION_SUMMARY["SYSTEM_ERROR"] = "System Error";
    NOTIFICATION_SUMMARY["ERROR"] = "Error";
    NOTIFICATION_SUMMARY["INFO"] = "Info";
    NOTIFICATION_SUMMARY["WARNING"] = "Warning";
})(NOTIFICATION_SUMMARY || (NOTIFICATION_SUMMARY = {}));
